export default "__VITE_ASSET__KoTcMtwE__"